import React from "react";
import { Grid, Paper, Typography } from "@mui/material";
import MainSectionContainer from "./MainSectionContainer";

const ComingSoon = () => {
  return (
    <MainSectionContainer>
      <Grid container alignItems="center" justifyContent="center" height="100%">
        <Paper
          elevation={5}
          style={{
            background: "linear-gradient(135deg, #3cb027 25%, #090909)",
            height: "50%",
            padding: 8,
          }}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            height="100%">
            <Grid item xs={12}>
              <Typography
                style={{ color: "#fff" }}
                width="100%"
                align="center"
                variant="h5"
                component="b">
                Page is under Construction
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </MainSectionContainer>
  );
};

export default ComingSoon;
